import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../css/pages/NotFound.css';
export default class NotFound extends React.Component {
  render() {
    return (
      <div>
      <p
          className="warning-resolution"
        >
          To view this page, a minimum resolution of
          320x500 pixels is required.
      </p>
      <section className="section-index">
        <div>
          <Header />
          <div
            className="container-not-found"
          >
            <div
              className="not-found-div-h1"
            >
              <h1
                className="not-found-h1"
              >
                404
              </h1>
            </div>
            <div
              className="not-found-div-h3"
            >
              <h3
                className="not-found-h3"
              >
                Página não encontrada!
              </h3>
            </div>
            <div
              className="not-found-div-p"
            >
              <p
                className="not-found-p"
                >
                A página que você está tentando acessar não existe ou foi removida.
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </section>
    </div>
      
    );
  }
}
